<template>
    <div class="node-container">
        <div class="content-wrap">
            <h2>您对这次“项目”的感觉如何？</h2>
            <ul class="score-wrap">
                <li v-for="item in scoreList" :key="item.id" @click="handleScore(item.id)">
                    <img :src="score === item.id ? item.imgActive : item.imgsrc" alt="">
                    <span :style="{'color': score === item.id ? '#333' : '#ccc'}">{{ item.name }}</span>
                </li>
            </ul>
            <el-input type="textarea" v-model="evaluation" placeholder="请输入您的评价内容" maxlength="1000" show-word-limit :autosize="{ minRows: 5, maxRows: 10}"
                :disabled="!isCurrent || type === 'preview'" />
        </div>
        <!-- 底部按钮 -->
        <div class="footer-operation" v-if="type != 'preview' && isCurrent">
            <el-button @click="onRollback">上一步</el-button>
            <el-button type="primary" :loading="loadSubmit" @click="onSubmit">确定</el-button>
        </div>
    </div>
</template>

<script>
import { findRequirementEvaluation, addRequirementEvaluation, updateRequirementEvaluation } from '@/api/requirement'

export default {
    props: {
        requirementId: [Number, String],
        currentStep: [Number, String],
        // 弹窗类型：add 新增 | edit 编辑 | preview 预览
        type: String,
    },
    data() {
        return {
            scoreId: null,
            score: null,
            evaluation: '',
            scoreList: [
                { id: 1, name: '很不满意', imgsrc: require("@/assets/image/requirement/icon-star1.png"), imgActive: require("@/assets/image/requirement/icon-star1-active.png") },
                { id: 2, name: '不满意', imgsrc: require("@/assets/image/requirement/icon-star2.png"), imgActive: require("@/assets/image/requirement/icon-star2-active.png") },
                { id: 3, name: '一般', imgsrc: require("@/assets/image/requirement/icon-star3.png"), imgActive: require("@/assets/image/requirement/icon-star3-active.png") },
                { id: 4, name: '满意', imgsrc: require("@/assets/image/requirement/icon-star4.png"), imgActive: require("@/assets/image/requirement/icon-star4-active.png") },
                { id: 5, name: '很满意', imgsrc: require("@/assets/image/requirement/icon-star5.png"), imgActive: require("@/assets/image/requirement/icon-star5-active.png") }
            ],
            loadSubmit: false
        }
    },
    computed: {
        // 进度是否为当前节点
        isCurrent() {
            return this.currentStep === 4 ? true : false
        }
    },
    methods: {
        // 打分
        handleScore(id) {
            // 禁用
            if (!this.isCurrent || this.type === 'preview') {
                this.$MessageBox.MessageWarning("请进入编辑模式");
                return;
            }

            if (id === this.score) {
                this.score = null;
            } else {
                this.score = id;
            }
        },
        // 回显表单信息
        echoInfo() {
            if (!this.requirementId) return;
            findRequirementEvaluation({ requirementId: this.requirementId }).then(res => {
                if (res.data) {
                    this.scoreId = res.data.id;
                    this.score = res.data.score;
                    this.evaluation = res.data.evaluation;
                } else {
                    this.scoreId = null;
                    this.score = null;
                    this.evaluation = null;
                }
            }).catch(err => {
                this.scoreId = null;
                this.score = null;
                this.evaluation = null;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 点击“上一步” 回退步骤
        onRollback() {
            this.$emit('rollback');
        },
        // 提交信息
        onSubmit() {
            if (this.score === null) {
                this.$MessageBox.MessageWarning("请评分");
                return
            }
            let reqApi = addRequirementEvaluation;
            if (this.scoreId) {
                reqApi = updateRequirementEvaluation;
            }
            reqApi({
                id: this.scoreId,
                requirementId: this.requirementId,
                score: this.score,
                // saleUserId
                evaluation: this.evaluation
            }).then(res => {
                this.loadSubmit = false;
                this.$emit('push');
                this.$MessageBox.MessageSuccess(res.msg);
            }).catch(err => {
                this.loadSubmit = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 500px;
    padding: 20px 0;
    margin: 0 auto;
    .score-wrap {
        display: flex;
        justify-content: space-evenly;
        width: 100%;
        margin-top: 30px;
        margin-bottom: 50px;
        list-style: none;
        > li {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            img {
                height: 5rem;
            }
            &:last-of-type {
                span {
                    margin-left: -5px;
                }
            }
        }
    }
}
.footer-operation {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    > .el-button {
        height: 32px;
        line-height: 31px;
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>